import React, { Component } from "react";
import Link from "gatsby-link";
import Main from '../components/Main';


export default() =>
<div>
  <Main />
</div>


// WEBPACK FOOTER //
// ./src/pages/index.js